// src/ui/format.js — number / date formatting shared by every page.

/** 0.6721 → "67.2%" ; null/NaN → "–" */
export function pct(ratio, digits = 1) {
  if (ratio == null || !Number.isFinite(Number(ratio))) return "–";
  return `${(Number(ratio) * 100).toFixed(digits)}%`;
}

/** wins / games as a ratio, null when there are no games. */
export function rate(wins, games) {
  return games > 0 ? wins / games : null;
}

/** "20260530" → "30/05/26" (short) or "30/05/2026" (long). Anything else is returned trimmed. */
export function ymd(value, { long = false } = {}) {
  const s = String(value ?? "").replace(/\.0$/, "").trim();
  if (!/^\d{8}$/.test(s)) return s || "–";
  const yyyy = s.slice(0, 4);
  return `${s.slice(6, 8)}/${s.slice(4, 6)}/${long ? yyyy : yyyy.slice(2)}`;
}

/** Thai short weekday + date: "ส. 30 พ.ค." */
const TH_MONTHS = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
export function ymdThai(value) {
  const s = String(value ?? "").replace(/\.0$/, "").trim();
  if (!/^\d{8}$/.test(s)) return s || "–";
  return `${Number(s.slice(6, 8))} ${TH_MONTHS[Number(s.slice(4, 6)) - 1] || ""} ${s.slice(2, 4)}`;
}

/** 13.6 → "13.6" minutes; blanks → "–" */
export function minutes(value, digits = 1) {
  const n = Number(value);
  if (value === "" || value == null || !Number.isFinite(n) || n <= 0) return "–";
  return n.toFixed(digits);
}

/** Signed number: 4.75 → "+4.75", -2 → "−2" */
export function signed(value, digits = 1, suffix = "") {
  const n = Number(value);
  if (!Number.isFinite(n)) return "–";
  const s = Math.abs(n).toFixed(digits);
  if (Number(s) === 0) return `±0${suffix}`;
  return `${n > 0 ? "+" : "−"}${s}${suffix}`;
}

export function int(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toLocaleString("en-US") : "–";
}

export function median(values) {
  const v = values.filter((x) => Number.isFinite(x)).sort((a, b) => a - b);
  if (!v.length) return null;
  const m = Math.floor(v.length / 2);
  return v.length % 2 ? v[m] : (v[m - 1] + v[m]) / 2;
}

export function mean(values) {
  const v = values.filter((x) => Number.isFinite(x));
  return v.length ? v.reduce((a, b) => a + b, 0) / v.length : null;
}
